<script lang="ts" setup>
import type { CellItem } from './calendar.type'

import { sdCalendarProps } from './calendar'
import { computed        } from 'vue'
import { dt              } from '@sumdoo/shared'

import CalendarPanel from './calendar-panel.vue'

defineOptions({ name: 'SdCalendar' })

const props = defineProps(sdCalendarProps)
const emit  = defineEmits(['pick'])

const date$ = computed(() => {
    return props.modelValue instanceof Date ? props.modelValue : new Date(props.modelValue)
})

const today$ = computed(() => {
    return dt.format(new Date())
})
    
const monthTitle$ = computed(() => {
    return dt.format(date$.value, 'YYYY 年 MM 月')
})

function onPickDay(cell: CellItem) {
    emit('pick', cell)
}

const calendarStyle$ = computed(() => {
    return {
        width: typeof props.width === 'number' ? `${props.width}px` : props.width, 
    }
})


</script>

<template>
    <div class="sd-calendar" :style="[calendarStyle$]">
        <div class="sd-calendar__head">
            {{ monthTitle$ }}
        </div>
        <div class="sd-calendar__body">
            <CalendarPanel 
                :date="date$" 
                :today="today$"
                :firstDayOfWeek="firstDayOfWeek"
                :selectedDay="defaultSelected"
                :cellStyle="cellStyle"
                @pick="onPickDay"
            >
                <template v-if="$slots.cell" #cell="{ data }">
                    <slot name="cell" v-bind="data"></slot>
                </template>
            </CalendarPanel>
        </div>
    </div>
</template>
